import { Routes } from '@angular/router';
import { resolveMeta } from '@core/handlers/core.handlers';
import { IMetaData } from '@core/types/meta';
import { ArticlePageComponent } from '@pages/articles/article-page/article-page.component';
import { ArticlesComponent } from '@pages/articles/articles.component';
import { ArticlesPageComponent } from '@pages/articles/articles-page/articles-page.component';
import { articleGuard } from '@pages/articles/guards/article.guard';
import { clearTagParamsGuard } from '@pages/articles/guards/clear-tags-params.guard';
import { articleResolver } from '@pages/articles/resolvers/article.resolver';
import { articlesResolver } from '@pages/articles/resolvers/articles.resolver';

const META_DESCRIPTION: IMetaData = {
  methodName: 'routeMetaDescription',
  name: 'description',
  title: 'meta.articles.title',
  content: 'meta.articles.description',
};

export const ROUTES_ARTICLES: Routes = [
  {
    path: '',
    component: ArticlesComponent,
    canDeactivate: [clearTagParamsGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ArticlesPageComponent,
        resolve: {
          ...resolveMeta(META_DESCRIPTION),
          articlesData: articlesResolver,
        },
      },
      {
        path: ':id',
        component: ArticlePageComponent,
        resolve: { articleResolver },
        canActivate: [articleGuard],
      },
    ],
  },
];
